/**
 * Styled components for Gate Deviation Chart Legend
 */

import styled from 'styled-components/macro';
import { CHART_CONSTANTS } from '../constants';

export const LegendRoot = styled.div.attrs({
  className: 'gate-deviation-legend__root',
})`
  padding: 0 55px;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const LegendSection = styled.div.attrs({
  className: 'gate-deviation-legend__section',
})``;

export const LegendHeading = styled.h5.attrs({
  className: 'gate-deviation-legend__heading',
})`
  margin-bottom: 10px;
`;

/** Circle marker matching same-direction points in the chart */
export const SameDirectionMarker = styled.span.attrs({
  className: 'gate-deviation-legend__marker-same',
})`
  display: inline-block;
  width: ${CHART_CONSTANTS.POINT_RADIUS * 2}px;
  height: ${CHART_CONSTANTS.POINT_RADIUS * 2}px;
  border-radius: 50%;
  background-color: #666;
  flex-shrink: 0;
`;

/** Triangle marker matching opposite-direction points in the chart */
export const OppositeDirectionMarker = styled.span.attrs({
  className: 'gate-deviation-legend__marker-opposite',
})`
  display: inline-block;
  width: ${CHART_CONSTANTS.POINT_RADIUS * 2}px;
  height: ${CHART_CONSTANTS.POINT_RADIUS * 2}px;
  background-color: #666;
  flex-shrink: 0;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
`;

/** Container for a group of legend items (direction or gate values) */
export const LegendItemsContainer = styled.div.attrs({
  className: 'gate-deviation-legend__items',
})`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 10px;
`;

/** Single legend row: marker + label */
export const LegendItem = styled.span.attrs({
  className: 'gate-deviation-legend__item',
})`
  display: flex;
  align-items: center;
  gap: 8px;
`;
